import React, { useState, useRef } from 'react';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';

// Icons
import Close from 'svg/close';
import Arrow from 'svg/arrow';

// Images
import video_option_1 from 'static/images/share_1.png';
import video_option_2 from 'static/images/share_2.png';
import video_option_3 from 'static/images/share_3.png';
import video_option_4 from 'static/images/share_4.png';
import video_option_5 from 'static/images/share_5.png';

//env config
import env_config from 'env_config.js';

// install Swiper components
SwiperCore.use([Navigation]);

/**
 * Download
 *
 * Download those massive choons bruv
 */
const Download = (props) => {
  const close = props.closeAction;
  // URL Endpoint
  // const baseURL = 'https://server-dot-dl-rp-universe.uk.r.appspot.com';

  let baseURL = 'https://us-east4-dl-rp-universe.cloudfunctions.net/NA';
  if(process.env.REACT_APP_ENV){
    baseURL = env_config[process.env.REACT_APP_ENV].cloud_function_url || baseURL
  }
  // State
  const [isGenerating, setIsGenerating] = useState(false);
  const [generatingType, setGeneratingType] = useState(null);
  const [isDone, setIsDone] = useState(false);
  const [error, setError] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState('');
  const [copyUrl, setCopyUrl] = useState('');
  // Refs
  const videoChoice = useRef(0);
  const copyUrlInput = useRef(null);

  /**
   * Generate the output
   * @param  {Boolean} isVideo [whether to generate video or not]
   */
  const generate = (isVideo = true) => {
    if (props.recording.size) {
      if (isVideo) {
        setGeneratingType('video');
      } else {
        setGeneratingType('audio');
      }
      setIsGenerating(true);
      const fd = new FormData();
      fd.append('uuid', uuidv4());
      fd.append('videoId', videoChoice.current);
      fd.append('audio', props.recording);
      fd.append('isVideo', isVideo);
      axios({
        method: 'post',
        url: baseURL,
        headers: {'Content-Type': 'multipart/form-data' },
        data: fd
      }).then(res => {
        setIsGenerating(false);
        setDownloadUrl(res.data.mediaLink);
        setCopyUrl(res.data.mediaLink);
        setIsDone(true);
      }).catch(err => {
        setIsGenerating(false);
        setError('Unfortunately an error occured while processing your download. Please try again later.');
        setIsDone(true);
      });
    } else {
      setIsGenerating(false);
      setError('It looks like no sound was recorded – are you playing any music? Please try again.');
      setIsDone(true);
    }
  }

  return (
    <article className='Main-overlay Download'>
      {/*Actions to control the Download*/}
      <button
        title='Close'
        className='button button--outline button__close'
        onClick={close}
      >
        <Close className='Download__icon Download__icon-close' title='Close' />
      </button>
      {(!isDone && !isGenerating) && (
        <section className='Download-slides'>
          <h3 className='Download-slides__title title'>Choose Your Vibe</h3>
          <Swiper
            spaceBetween={100}
            slidesPerView={1}
            onSlideChange={(swiper) => { videoChoice.current = swiper.activeIndex; }}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }}
          >
            <SwiperSlide>
              <img className='Download-slides__image' src={video_option_1} alt='Video Option One' />
            </SwiperSlide>
            <SwiperSlide>
              <img className='Download-slides__image' src={video_option_2} alt='Video Option Two' />
            </SwiperSlide>
            <SwiperSlide>
              <img className='Download-slides__image' src={video_option_3} alt='Video Option Three' />
            </SwiperSlide>
            <SwiperSlide>
              <img className='Download-slides__image' src={video_option_4} alt='Video Option Four' />
            </SwiperSlide>
            <SwiperSlide>
              <img className='Download-slides__image' src={video_option_5} alt='Video Option Five' />
            </SwiperSlide>
          </Swiper>
          <button title='Arrow Right' className='swiper-button swiper-button-next'><Arrow className='swiper-button-icon' /></button>
          <button title='Arrow Left' className='swiper-button swiper-button-prev'><Arrow className='swiper-button-icon' /></button>
          <button
            className='button Download-slides__generate'
            onClick={() => {
              generate(true);
            }}
          >Generate Music Video</button>
          <button
            className='Download-slides__music-only'
            onClick={() => {
              generate(false);
            }}
          >Just the sound, please</button>
        </section>
      )}
      {(isGenerating && !isDone) && (
        <section className='Download__generating'>
          <h3 className='button button--outline Download__heading'>Generating {generatingType}</h3>
          <figure className='Animation-wiggle'>
            <div className='Animation-wiggle__icon'></div>
          </figure>
        </section>
      )}
      {isDone && (
        <>
          {error ? (
            <div className='GenericAlert'>
              <h1 className='GenericAlert__title'>Sorry</h1>
              <section className='GenericAlert__description'>
                <p>{error}</p>
              </section>
              <div className='GenericAlert__buttons'>
                <button className='button GenericAlert__button' onClick={props.closeAction}>Ok</button>
              </div>
            </div>
          ) : (
            <section className='Download__done'>
              <h3 className='button button--outline Download__heading'>Your {generatingType} is ready</h3>
              <div className='Download__done-buttons'>
                <a
                  className='button Download__done-save'
                  href={downloadUrl}
                  download={/(mp3)/.test(downloadUrl) ? 'myrpbeats.mp3' : 'myrpbeats.mp4'}
                >Save to Phone</a>
                <input type='text' value={copyUrl} readOnly={true} ref={copyUrlInput} />
                <button className='button Download__done-copy' onClick={() => {
                  const copyText = copyUrlInput.current;
                  copyText.select();
                  document.execCommand('copy');
                }}>Copy Link</button>
              </div>
            </section>
          )}
        </>
      )}
    </article>
  );
};

export default Download;

